module.exports = __webpack_public_path__ + "img/usesection3.b4496e2d.png";